import { categoryTranslationsMap } from './utils';

window.dataLayer = window.dataLayer || [];

export function handleSearchResultTracking(event, eventAction, elementData) {
  const dataLayerPayload = {
    event: event,
    eventCategory: 'search',
    eventAction: eventAction,
    eventLabel: '',
    keyword: elementData.searchText,
    search_results: {
      selection: elementData.ourSelectionItems.map(item => item.phrase),
      location: elementData.locationSuggestions.map(
        item => item.label + ' - ' + elementData.translate(categoryTranslationsMap[item.category]),
      ),
      products: elementData.productSuggestions.map(product => product.identifier.toString()),
      popular: elementData.popularSearches,
    },
  };
  window.dataLayer.push(dataLayerPayload);
}

export function handleClickedItemResultTracking(event, eventAction, searchText, itemType, itemText) {
  const dataLayerPayload = {
    event: event,
    eventCategory: 'search',
    eventAction: eventAction,
    eventLabel: '',
    keyword: searchText,
    search_results: {
      selection: itemType === 'selection' ? [itemText] : [],
      location: itemType === 'location' ? [itemText] : [],
      products: itemType === 'product' ? [itemText] : [],
      popular: itemType === 'popular' ? [itemText] : [],
    },
  };
  window.dataLayer.push(dataLayerPayload);
}
